import * as React from "react";
import { MapPin } from "lucide-react";

import { FooterStyles } from "./FooterStyles";
import { useTheme } from "../../../providers/ThemeContext";
import { useI18n } from "../../../languages/providers/I18nProvider";
import { footerKeys, footerData } from "./FooterContent";
import stylesCss from "./footer.module.css";

const FooterAddress: React.FC<{ showMap?: boolean }> = ({ showMap = true }) => {
  const { t } = useI18n();
  const { theme } = useTheme();
  const styles = FooterStyles(theme);

  const address = t(footerData.reach.address);
  const mapUrl = t(footerData.reach.mapUrl);

  const iframeSrc =
    footerData.reach.mapEmbedSrc ??
    `https://www.google.com/maps?q=${encodeURIComponent(
      address
    )}&z=15&output=embed`;

  return (
    <div style={{ marginInlineEnd: "10px" }}>
      <div style={styles.colTitle}>{t("footer:labels:address")}</div>

      <div style={styles.contactItem}>{address}</div>

      {showMap && (
        <div style={styles.mapFrameWrap as React.CSSProperties}>
          <iframe
            title="Creation Arts location"
            src={iframeSrc}
            loading="lazy"
            style={styles.mapFrame as React.CSSProperties}
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      )}

      <a
        href={mapUrl}
        target="_blank"
        rel="noreferrer"
        style={styles.footerDirectionLink as React.CSSProperties}
        className={stylesCss.footerLink}
      >
        <MapPin size={16} />
        {t(footerKeys.getDirections)}
      </a>
    </div>
  );
};

export default FooterAddress;
